import React from "react";
import Header from '../header2';

export default function Navbar(props) {
  return (
    <Header hclass={props.hclass} Logo={props.Logo} topbarClass={props.topbarClass} btnClass={props.btnClass}/>
  );
}
